import { z } from 'zod';
import { ExtraOrganizations } from 'libs/end-to-end/src/admin';
import { OrganizationUserRole } from 'libs/end-to-end/src/types/users/organization-user-roles';

export const EnrollmentTypes = ['local', 'sso-automatic'] as const;
export const EnrollmentType = z.enum(EnrollmentTypes);
export type EnrollmentType = z.infer<typeof EnrollmentType>;

export const User = z.object({
  id: z.string().min(1),
  // Optional fields here reflect older versions of the document that were stored without these.
  isSuperAdmin: z.boolean().optional(),
  organizationId: z.string().optional(),
  organizationRole: OrganizationUserRole.optional(),
  passwordResetToken: z.string().optional(),
  passwordResetTokenExpiresAtMilliseconds: z.number().optional(),
  email: z.string().min(1),
  cognitoUsername: z.string().optional(),
  enrollmentType: EnrollmentType.optional(),
  extraOrganizations: ExtraOrganizations.optional(),
});

export type User = z.infer<typeof User>;
